import { PageNavigation } from "components/PageNavigation";
import { Container, Paper, Typography } from "@material-ui/core";
import React from "react";

export function EmptyPage({ text, children }: { text?: string, children?: React.ReactNode }) {
    return (
        <PageNavigation>
            <Container maxWidth="sm">
                <Paper style={{ marginTop: 50, paddingTop: '10vh', paddingBottom: '10vh', margin: 'auto' }} elevation={10}>
                    {text && <Typography variant="h2" align="center">{text || 'Tom side'}</Typography>}
                    {children}
                </Paper>
            </Container>
        </PageNavigation>
    );
}